import React, { useCallback, FunctionComponent } from 'react';
import { userSettingsPageSelectors } from '../../../../app/page/page-storage/user-settings/user-settings.selectors';
import { useSelect } from '../../../../utils/selector.utils';
import { openDialog } from '../../../../app/dialog/dialog.actions';
import { useDispatch } from 'react-redux';

export const OpenCalendarFormButton: FunctionComponent = () => {
  const dispatch = useDispatch();
  const googleCalendarEmbedUrl = useSelect(userSettingsPageSelectors.selectGoogleCalendarEmbedUrl);

  const openNewWindow = useCallback(() => {
    dispatch(openDialog('googleCalendarEmbedUrlFormDialog'));
  }, [dispatch]);

  return (
    <button
      className="btn-badge themed-bg green-bg popup_button flex justify-center"
      data-popup="new_todo_popup"
      title={googleCalendarEmbedUrl ? 'Edit' : 'Add'}
      onClick={openNewWindow}
    >
      <i className={googleCalendarEmbedUrl ? 'icon-pencil' : 'icon-plus'}></i>
    </button>
  );
};
